var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-agir"},[_c('p',{staticClass:"footer-agir__texto"},[_vm._v(" © "+_vm._s(_vm.ano)+" "),_c('strong',[_vm._v("Agir 360")]),_vm._v(". Todos os direitos reservados. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }